import React from "react";
import { Mail, Phone, MessageCircle, MapPin, BookOpen } from "lucide-react";

export default function Support() {
  return (
    <div className="max-w-5xl">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-widest text-[var(--text-2)] mb-2">Administration</div>
        <h1 className="font-serif text-4xl">Support &amp; Docs</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
        <div className="card-sharp p-6" data-testid="contact-card">
          <div className="ledger-head mb-4">Contact</div>
          <ul className="text-sm space-y-3">
            <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[var(--primary)]" /> Beirut, Lebanon</li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[var(--primary)]" />
              <a href="mailto:info@eventsmanagement.team" className="underline underline-offset-4">info@eventsmanagement.team</a>
            </li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[var(--primary)]" />
              <a href="tel:+96181998100" className="mono">+961 81 998 100</a>
            </li>
            <li className="flex items-center gap-3"><MessageCircle className="w-4 h-4 text-[var(--primary)]" />
              <a href="https://wa.me/96181998100" target="_blank" rel="noreferrer" className="underline underline-offset-4 mono">WhatsApp +961 81 998 100</a>
            </li>
          </ul>
        </div>

        <div className="card-sharp p-6">
          <div className="ledger-head mb-4">Hours</div>
          <div className="text-sm text-[var(--text-2)] leading-relaxed">
            Monday – Friday · 09:00 – 18:00 EET<br />
            Priority support for active productions is available 24/7 during live event days.
          </div>
        </div>
      </div>

      <div className="card-sharp p-8">
        <div className="flex items-center gap-2 ledger-head mb-4"><BookOpen className="w-4 h-4" /> Quick Guide</div>
        <ol className="space-y-4 text-sm">
          <li><b>1. Create an event.</b> Same event on different dates → create separate entries. Each is a discrete P&amp;L.</li>
          <li><b>2. Add ticket tiers, sponsorships and OneDrive link</b> on the event detail page.</li>
          <li><b>3. Log costs</b> as either <span className="mono">budget</span> (forecast) or <span className="mono">actual</span>. Actual entries require source and payment gateway.</li>
          <li><b>4. Log sales</b> per channel — the Revenue Projection chart is a rolling cumulative of your sales entries.</li>
          <li><b>5. Upload posters</b> in Media Assets. Add a YouTube URL to embed the trailer.</li>
          <li><b>6. Administer users</b> — pending sign-ups need an admin activation to log in.</li>
        </ol>
      </div>
    </div>
  );
}
